import { Observable } from "rxjs";
import { CostOverview } from "../costOverview";

export abstract class CostOverviewData {
  abstract listCost(scenarioId: number): Observable<any>;

  abstract update(cost: CostOverview): Observable<any>;
}
